import axios from 'axios';
import React, { useState } from 'react'
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux'
import { Button, Card, Main } from '../../Components';
import { ReactComponent as Logo } from './../../assets/logo/logo.svg'
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import moment from 'moment'
import { updateOrganization, updateUserMemberships, updateUserOrganizations } from '../../Redux/features/authSlice';

import './joinTeam.css'

export function JoinTeam() {

	const [state, setState] = useState({

		organization_name : ''	,
		sender_email : "",
		recipient_email : "",
		joined : false,
		redirected_to_authPage : false,
		// isForuser: false,
		invite_expiryDate : null,
		response : '',
		response_status : 'danger',
		invite_isClaimed : false,
		checUserConnection : false
	})
	const { inviteId} = useParams();
	const [isLoading, setIsLoading] = useState(true)
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const { user , org } = useSelector((state) => state.auth)

	useEffect(() => {

		getInvitationData()

	}, [])
	
	/**
	 * 
	 */
	const getInvitationData = () => {

		 

		axios
			.get(`${process.env.REACT_APP_API_URL}/invites/${inviteId}`, 
			{
				
			})
			.then( res => res.data)
			.then( response => {
				//console.log('getInvitationData : ',  response);
				setState(prevState => ({
					...prevState,
					organization_name : response?.organization?.name,
					sender_email : response?.inviter?.email,
					sender_name : response?.inviter?.name,
					recipient_email : response?.email,
					invite_expiryDate : response?.expiry_date,
					invite_isClaimed : response?.claimed
				}));

				setIsLoading(false)

			})
			.catch(error => {

				//console.log('error : ' , error);
				if (error.response) {
					 toast.error(error?.response?.data?.message) 
					
				} else {
					// Something happened in setting up the request that triggered an Error
					if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
						 
						
						toast.error("An error occurred while logging into your organization, please try again later") 
						
						
					
					}
				} 

				setState( prevState => ({
					...prevState,
					joined : true,
					response: "Sorry, the invite you are using is either invalid or expired. Ask the person that invited you to send another invite.",
					response_status : 'danger'
				}))

				setIsLoading(false)

				
				
				
			}) 
	}

	/**
	 * 
	 * @returns 
	 */
	const  validateJoinTeam = async () => {

		// Add join Token ( invite id ) to storage ( then in signin / signup process, we get this id and pass it to api for validation)
		localStorage.setItem(`${process.env.REACT_APP_STORAGE__INVITE_TOKEN}` , inviteId)


		if (user && state.recipient_email === user?.email){
			// validation immediately of invitation by invite id (token)
			////console.log('validation ......');
			if (moment(state.invite_expiryDate).diff(moment() , 'minutes') > 0){

				

				if (user && user.token) {
					
					const { token } = user;
					
					const headers = {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
						 
					}
			
					 
					

					await axios
						.post(`${process.env.REACT_APP_API_URL}/invites/${inviteId}/validate`, {
							email : state.recipient_email
						}, {
							headers: headers,
						})
						.then(res => res.data )
						.then( data => {    

                            const org = data?.user?.organizations?.find(x => x.is_default === true ) ?? (data?.user?.organizations?.length > 0 ? data?.user?.organizations[0] : {})
                            // Update the redux 
							dispatch(updateUserMemberships(data?.user?.memberships));                 
							dispatch(updateUserOrganizations(data?.user?.organizations));    
							dispatch(updateOrganization(org));    

							 

							setState(prevState => ({
								...prevState,
								error_code : 0,
								response: data?.message,
								response_status: 'success',
								redirected_to_account : true
							}))

							// redirection to status pages list 
                            navigate(`/`)

						})
						.catch(err => {
							//console.log(err);

							if(typeof err.message==='undefined' || err.message ===null || err.message!=="API_HAS_BEEN_CANCELED"){
					
							 
							setState(prevState => ({
								...prevState,
								error_code : 101,
								response: err?.response?.data?.error_description,
								response_status : 'danger'
							}))
						}
						});
				} else {
					setState(prevState => ({
						...prevState,
						error_code : 102,
						response: "You are not authorized to do this operation",
						response_status : 'danger'
					}))
					return;
				}

			}else if(this.state.invite_isClaimed ===true ){
				setState(prevState => ({
					...prevState,
					error_code : 0,
					response:"Congratulations, the invite you are using is already valid, you are now a member in this account team.",
					response_status : 'danger'
				}))
			}else{
				setState(prevState => ({
					...prevState,
					error_code : 104,
					response:"Sorry, the invite you are using has expired. Ask the person that invited you to send another invite.",
					response_status : 'danger'
				}))
			}






		}else if (user){
			setState(prevState => ({
				...prevState,
				// isForuser : false,
				response : "Sorry, the invitation you are using is valid, but not for the current user.",
				response_status : 'danger'
			}))
		}else{

			navigate(`/login?invitationid=${inviteId}`)
			// setState(prevState => ({
			//     ...prevState,
			// 	redirected_to_authPage : true
			// }))
		}
	}

	/**
	 * 
	 */
	const gotoLogin = () => {
		navigate(`/login?invitationid=${inviteId}`)
	}




	return (
		<>
		<Helmet>
			<title>Join Team - {process.env.REACT_APP_APP_NAME}</title>
		</Helmet>
		<Main size={`full`} withNav={false} positionY="top"  >
			<div className="layout-login-form join-team-form">
				<div className="logo-wrapper">
					<Logo />
				</div> 
				<Card shadow="md" target="login">
					<form >
						{
							isLoading 
							? 'Loading ...'
							: <>
								<div className='title'>{state.joined ===true ? 'That invite URL is not valid' : 'Join your team on Status Way'}</div>
								{
									state.response !==''
										? <p className={`alert alert-${state.response_status} text-${state.response_status}`}>{state.response}</p> 
										: <>
											<div className="invitation-details">
												<label htmlFor="">You were invited by </label>
												<span>{state.sender_name !==null ? state.sender_name : state.sender_email}</span>
											</div>
											<div className="field-group submit-fields-group fluid">
												{
													user && user?.email === state.recipient_email
													? <Button onClick={validateJoinTeam} color="purple" >
														<span>Join now to <b>{state.organization_name}</b> team</span>
													</Button>
													: <Button onClick={gotoLogin} color="purple" >
														<span>Login or signup to join <b>{state.organization_name}</b> team</span>
													</Button>
												}
											</div>
										</>
								}
							</>
						 
						}

						
					</form>
				</Card>
                {
                    !user && 
				    <div className='under-form'>Don't have an account? <Link to="/registration">Sign up</Link></div>
                }
			</div>
		</Main>
		</>
	)
}
